import * as types from "../types/allOrdersType";
import { initialOrderState } from "../initialState";

export const allorders = (state = initialOrderState, action) => {
  switch (action.type) {
    case types.ORDER_READ:
      var newState = { ...state };
      newState.read = action.orders;
      return newState;
    default:
      return state;
  }
};

// export const
